import React from 'react'
import { observer } from 'mobx-react-lite'
import IconButton from '@mui/material/IconButton'
import Tooltip from '@mui/material/Tooltip'
import { CustomTableStore, useCustomTableStore } from '../CustomTableStore'
import useCustomTableRenderLog from '../hooks/useCustomTableRenderLog'
import useStore from 'reusable/mobx-store-utils'

interface CustomTableActionProps<RowData extends AnyObject> {
   title: string
   callback: (data: RowData[]) => any
   icon: () => React.ReactElement<any>
}

export const CustomTableMultipleRowAction = observer(function CustomTableMultipleRowAction
   <RowData extends AnyObject, RowStore>(props: CustomTableActionProps<RowData>) {
   useCustomTableRenderLog('CustomTableMultipleRowAction')
   const customTableStore = useCustomTableStore<CustomTableStore<RowData, RowStore>>()

   const localStore = useStore(
      sp => ({
         callback: () => {
            const selectedRows = customTableStore.localRows.filter(l => l.selected).map(l => l.row)
            sp.callback(selectedRows)
         },
         get icon() {
            return sp.icon()
         },
      }),
      props
   )

   return (
      <Tooltip title={props.title}>
         <IconButton onClick={localStore.callback} size="large">
            {localStore.icon}
         </IconButton>
      </Tooltip>
   )
}
)
